import {
  type AccountStateByPortfolioSymbol,
  type AccountStateTimestamps,
  type PositionsByPairs,
} from "#/types/accounts";
import {
  MarginAccountStatePairs,
  Pairs,
  PortfolioSymbol,
} from "#/types/markets";

import { defaultGreeks } from "./greeks";

export const defaultAccountState = Object.fromEntries(
  Object.values(PortfolioSymbol).map((portfolioSymbol) => [
    portfolioSymbol,
    {
      pair: MarginAccountStatePairs[portfolioSymbol],
      imr: 0,
      mmr: 0,
      equity: 0,
      mm: 0,
      im: 0,
      greeks: defaultGreeks,
      isLiquidated: false,
    },
  ]),
) as AccountStateByPortfolioSymbol;

export const defaultAccountStateTimestamps = Object.fromEntries(
  Object.values(PortfolioSymbol).map((portfolioSymbol) => [portfolioSymbol, 0]),
) as AccountStateTimestamps;

export const defaultPositions = Object.fromEntries(
  Object.values(Pairs).map((pair) => [pair, []]),
) as unknown as PositionsByPairs;
